import { getLanguageFile } from "../../common/GetLanguageFile";

export const SaveButton = (
  props: {
    savingBool?: boolean;
    isTemp?: boolean;
  } & React.ButtonHTMLAttributes<HTMLButtonElement>
) => {
  const { savingBool, isTemp, ...otherProps } = props;

  return (
    <button style={{ flex: 1 }} disabled={savingBool} {...otherProps}>
      {savingBool
        ? getLanguageFile("generics.saving")
        : isTemp
        ? getLanguageFile("generics.create")
        : getLanguageFile("generics.save")}
    </button>
  );
};
